<!-- @format -->

<template>
	<el-tabs :id="item.code" v-model="activeTab" class="tabs" @tab-change="onTabChange">
		<el-tab-pane
			v-for="(itm, idx) in item.children"
			:key="`${itm.pcProps.label}_${idx}`"
			:label="itm.pcProps.label"
			:name="itm.pcProps.label"
		>
			<template v-if="!(itm as Container).children.length && status === 'widget'">
				<el-empty class="not-content" :image-size="50" description="请从左侧拖拽字段" />
			</template>
			<slot :data="itm"></slot>
		</el-tab-pane>
	</el-tabs>
</template>

<script setup lang="ts">
	import Script from '../../utils/script';
	import type { Container } from '../../types';

	interface Props {
		item: Container & {
			pcProps: {
				activeTab: string;
			};
		};
		modelValue?: any;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const status = inject('form-status', 'widget');

	const fieldActionConfig = inject<Record<string, Function>>('fieldActionConfig', {});

	const scriptConfig: Script | undefined = inject('scriptConfig', undefined);

	const activeTab = ref(props.item.children[0].pcProps.label);

	const stateActiveTab = computed(() => props.item.children.find((i) => (i as Container).isActive)?.pcProps.label);

	watch(
		stateActiveTab,
		(newVal) => {
			activeTab.value = newVal;
		},
		{
			immediate: true,
		},
	);

	const onTabChange = (e: string) => {
		props.item.pcProps.activeTab! = e;
		if (props.item.pcProps.onTabChangeScript) {
			if (fieldActionConfig['onTabChangeScript']) {
				fieldActionConfig['onTabChangeScript'](props.item);
			} else if (scriptConfig) {
				(scriptConfig as Script).runScript(
					props.item.pcProps.code as string,
					'onTabChangeScript',
					props.item.pcProps.onTabChangeScript,
				);
			}
		}
	};
</script>

<style scoped lang="scss">
	.tabs {
		width: 100%;

		:deep(.el-tabs__content) {
			position: relative;
			padding-bottom: 0px;

			.not-content {
				height: 100px;
				width: 100%;
				position: absolute;
			}

			.widget-form {
				min-height: 100px;
			}
		}
	}
</style>
